import { CurrencyPair } from '../CurrencyPair';
import { StpAbosAccount } from '../StpAbosAccount';
import { CurrencyPairPriceDto } from './CurrencyPairPriceDto';

export class StpPreload {
  currencies: Array<CurrencyPair>;
  accounts: Array<StpAbosAccount>;
  prices: CurrencyPairPriceDto;

  constructor(currencies: Array<CurrencyPair>, accounts: Array<StpAbosAccount>, prices: CurrencyPairPriceDto) {
    this.currencies = currencies;
    this.accounts = accounts;
    this.prices = prices;
  }
}
